export default __webpack_public_path__ + "static/media/privacy.987550c0.md";